import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import {
  Container,
  FormControl,
  InputGroup,
  OverlayTrigger,
  Spinner,
  Tooltip,
} from "react-bootstrap";
import ProductCard2 from "../ProductCard/ProductCard2";
import "./ProductList.css";
import "../../App.css";
import { HiOutlineArrowNarrowLeft } from "react-icons/hi";
import { useNavigate, useLocation } from "react-router-dom";
import NoData from "../../Images/png/no_data.png";
import { usersData } from "../../App";
import { navWidget } from "./SharedNavWidget";
import InfiniteScroll from "react-infinite-scroll-component";
import { refreshToken } from "../../Actions/Auth";
import ErrorModal from "../Modals/ErrorModal";
import { BiSearch } from "react-icons/bi";
import useDebounce from "../../CustomHooks/useDebounce";
import { Common_Event_Hit } from "../../Actions/UserEvents";

const SharedProductList = () => {
  let navigate = useNavigate();
  let location = useLocation();
  const queryParams = new URLSearchParams(window.location.search);
  let navPath = location.pathname.split("/");
  const [productRes, setProductRes] = useState(null);
  const [dataLength, setDataLength] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const { userData } = useContext(usersData);
  const { setShowMaintenance } = useContext(usersData);
  const [errorModal, setErrorModal] = useState(false);
  const [homeShimmer, setHomerShimmer] = useState(false);
  const [screenName, setScreenName] = useState(null);
  const [subHead, setSubHead] = useState(null);
  const [searchString, setSearchString] = useState();
  const [updatedSearchValue, setUpdatedSearchValue] = useState();

  const PAGE_SIZE = 9;

  const accumulatedListRef = useRef([]);

  const getData = async (pageNum, searchValue = null) => {
    let selectedObj = navWidget.filter((item) => item.pageId === navPath[2])[0];
    if (!selectedObj) return;

    let api = selectedObj.api;
    let apiService = selectedObj.apiService;
    let params = {};
    setScreenName(selectedObj.screenName);

    if (selectedObj.pageId === "substitute") {
      params.medicineId = queryParams.get("medId");
      params.page = pageNum;
      params.pageSize = PAGE_SIZE;
      setSubHead(
        selectedObj.subHeading +
          queryParams.get("medName").split("%20").join(" "),
      );
    } else if (selectedObj.pageId === "composition") {
      params.compositionId = queryParams.get("compId");
      params.page = pageNum;
      params.pageSize = PAGE_SIZE;
      setSubHead(queryParams.get("compHead").split("%20").join(" "));
    } else {
      params.page = pageNum;
      params.pageSize = PAGE_SIZE;
      params.searchKey = searchValue;
    }

    try {
      let res = await apiService(api, params);
      setHomerShimmer(false);

      const pageItems = res?.data?.data?.medicinesResponsesList;
      const isEmpty = !pageItems || pageItems.length === 0;

      if (!isEmpty) {
        accumulatedListRef.current = [
          ...accumulatedListRef.current,
          ...pageItems,
        ];
        setProductRes({ medicinesResponsesList: accumulatedListRef.current });
        setDataLength(accumulatedListRef.current.length);
        setPage(pageNum);

        setHasMore(true);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshToken().then(() => getData(pageNum, searchValue));
      } else if (
        error?.response?.status === 502 ||
        error?.response?.status === 503 ||
        error?.response?.status === 504
      ) {
        setShowMaintenance({ status: true, apiData: error?.response });
      } else {
        setHasMore(false);
      }
    }
  };

  const fetchMoreData = () => {
    const next = page + 1;
    getData(next, updatedSearchValue);
  };

  const searchProducts = useDebounce(
    (value) => {
      Common_Event_Hit("DYNAMIC_EVENT", {
        eventName: "search_products",
        search_string: value,
        searchType: "Deals_SE",
      });
      accumulatedListRef.current = [];
      setPage(0);
      setProductRes(null);
      setDataLength(0);
      setHasMore(true);
      getData(0, value);
    },
    500,
    [searchString],
  );

  const handleEnter = (e) => {
    e.keyCode === 13 && e.stopPropagation();
  };

  const handleSearch = (e) => {
    setSearchString(e.target.value);
    setUpdatedSearchValue(e.target.value);
    document.getElementById("scrollableDiv").scrollTo(0, 0);
  };

  // Fires on initial mount AND whenever the URL query changes (new medicine/composition).
  // This replaces both the old useEffect([]) and handles SPA navigation correctly.
  useEffect(() => {
    window.scrollTo(0, 0);
    localStorage.setItem("currentScreen", "see_all_screen");
    localStorage.removeItem("currentScreenBannerData");

    // Reset all state for the new medicine/page
    accumulatedListRef.current = [];
    setPage(0);
    setProductRes(null);
    setDataLength(0);
    setHasMore(true);
    setHomerShimmer(true);

    const storedUser = localStorage.getItem("userData");
    if (storedUser && storedUser.length > 0) {
      getData(0, null);
    } else {
      navigate("/login");
    }
  }, [location.search, location.pathname]);

  useEffect(() => {
    if (
      navWidget &&
      navPath[2] === "nearExpiry" &&
      searchString !== undefined
    ) {
      searchProducts(searchString);
    }
  }, [searchString]);

  return (
    <Fragment>
      <ErrorModal
        show={errorModal.show}
        content={errorModal.content}
        apiData={errorModal?.apiData}
        onHide={() => {
          setErrorModal({ show: false, content: "" });
        }}
        tryAgain={() => {
          errorModal?.tryAgain();
          setErrorModal({ show: false, content: "" });
        }}
      />

      <Container fluid className="productList_cont">
        <Container
          fluid
          className="productListHeader pageListHeaderWithSearch font_ubuntu">
          <div>
            <HiOutlineArrowNarrowLeft
              className="cursor_pointer goBack"
              onClick={() => navigate(-1)}
            />
            &nbsp;&nbsp;&nbsp;
            {screenName}
            {subHead && (
              <OverlayTrigger
                placement={"bottom"}
                overlay={<Tooltip id={`tooltip-bottom`}>{subHead}</Tooltip>}>
                <span className="sub_head">{subHead}</span>
              </OverlayTrigger>
            )}
          </div>
          <div className="page_search_div">
            {navPath[2] === "nearExpiry" && (
              <InputGroup className="productListsearchBarDiv">
                <FormControl
                  className="searchBar border_none font_weight_md "
                  placeholder="Search deals se medicines"
                  spellcheck="false"
                  id="searchBar"
                  autoComplete="off"
                  value={searchString}
                  onKeyDown={handleEnter}
                  onChange={handleSearch}
                />
                <InputGroup.Text className="border_none cursor_pointer search_icon">
                  <BiSearch
                    style={{ fontSize: "20px", marginTop: "-5px" }}
                    className="color_grey search_icon"
                  />
                </InputGroup.Text>
              </InputGroup>
            )}
          </div>

          <div style={{ width: "15%" }}></div>
        </Container>

        {!homeShimmer &&
          productRes &&
          productRes.medicinesResponsesList.length > 0 && (
            <div
              id="scrollableDiv"
              className="productListDiv"
              style={{ paddingTop: "0rem" }}>
              <InfiniteScroll
                dataLength={dataLength}
                next={fetchMoreData}
                hasMore={hasMore}
                scrollableTarget="scrollableDiv"
                scrollThreshold="90%"
                className="infiniteScroll"
                loader={
                  <Spinner
                    animation="border"
                    className="color_secondary spinner"
                    size="lg"
                  />
                }>
                {productRes &&
                  productRes.medicinesResponsesList.map((med, index) => (
                    <ProductCard2
                      position={index}
                      screen={location?.state?.data?.pageId}
                      key={index}
                      medData={med}
                    />
                  ))}
              </InfiniteScroll>
            </div>
          )}

        {!homeShimmer &&
          productRes &&
          productRes.medicinesResponsesList.length === 0 && (
            <div
              id="scrollableDiv"
              className="productList "
              style={{ paddingTop: "50px" }}>
              <div className="no_data_parent">
                <img src={NoData} alt="No Data" />
                <br /> <br />
                <p className="font_ubuntu font_16 font_weight_md">
                  No Products Found !
                </p>
              </div>
            </div>
          )}
        {homeShimmer && (
          <div className="productList">
            {[...Array(5)].map((_, index) => {
              return (
                <div className="padding_5" key={index}>
                  <ProductCard2 shimmer={homeShimmer} />
                </div>
              );
            })}
          </div>
        )}
      </Container>
    </Fragment>
  );
};

export default React.memo(SharedProductList);
